export default function CTASection() {
  return (
    <section className="relative py-16 md:py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Stylish%20collection%20of%20fashion%20accessories%20shoes%20bags%20and%20clothing%20items%20arranged%20on%20light%20wooden%20floor%20near%20bright%20window%2C%20airy%20modern%20loft%20apartment%20interior%2C%20soft%20natural%20daylight%20streaming%20in%2C%20aspirational%20lifestyle%20scene%2C%20warm%20beige%20cream%20and%20soft%20olive%20tones%2C%20editorial%20fashion%20flat%20lay%20photography%20with%20organic%20composition&width=1600&height=700&seq=cta-bg-v2&orientation=landscape"
          alt="Start your BaseTao Spreadsheet research"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/55 via-black/35 to-black/55"></div>
      </div>

      <div className="relative z-10 max-w-[700px] mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-4">
          Start Your BaseTao Spreadsheet Research Today
        </h2>
        <p className="text-sm md:text-base text-background-50/80 mb-8 max-w-[500px] mx-auto leading-relaxed">
          Access comprehensive product databases, shipping guides, and exclusive deals. Join thousands of smart shoppers using BaseTao Spreadsheet.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 bg-accent-500 text-background-50 font-semibold text-sm rounded-lg hover:bg-accent-600 transition-all duration-200 cursor-pointer whitespace-nowrap inline-flex items-center justify-center gap-2"
          >
            <i className="ri-shopping-bag-3-line"></i>
            Buy It Now
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 bg-background-50/15 backdrop-blur-sm text-background-50 font-medium text-sm rounded-lg border border-background-50/30 hover:bg-background-50/25 transition-all duration-200 cursor-pointer whitespace-nowrap inline-flex items-center justify-center gap-2"
          >
            <i className="ri-external-link-line"></i>
            Visit BaseTao Spreadsheet
          </a>
        </div>
        <p className="text-xs text-background-50/50 mt-5">
          This is an independent research platform. We are not officially affiliated with BaseTao.
        </p>
      </div>
    </section>
  );
}